import ConditionField from "./ConditionField";
import AuthenticationCondition from "./conditionTypes/AuthenticationCondition.reg";
import ContainerCondition from "./conditionTypes/ContainerCondition.reg";
import GroupsCondition from "./conditionTypes/GroupsCondition.reg";
import InstitutionsCondition from "./conditionTypes/InstitutionsCondition.reg";
import RemoteConditionCondition from "./conditionTypes/RemoteConditionCondition.reg";
import RolesCondition from "./conditionTypes/RolesCondition.reg";
import WindowSizeCondition from "./conditionTypes/WindowSizeCondition.reg";

/**
 * common condition types
 * registered as InputType.CONDITION
 */

export default ConditionField.withOptions({
	types: [
		ContainerCondition,
		GroupsCondition,
		RolesCondition,
		AuthenticationCondition,
		WindowSizeCondition,
		RemoteConditionCondition,
		InstitutionsCondition
	]
});



// WEBPACK FOOTER //
// ./src/common/form/fields/condition/DefaultConditionField.ts